import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { IAuthorizationService } from '../../../services';
import { manualInputRoles } from '../../../common/Roles';

class QualityAnalysisController implements angular.IComponentController {
    static $inject = ['$scope', 'authorizationService'];

    currentState: angular.ui.IState;
    hasManualInputRole: boolean;
    searchParams: any;
    currentInterval: any;
    currentBeginDate: string;
    currentEndDate: string;

    constructor(private _$scope: angular.IScope,
        authorizationService: IAuthorizationService) {
        this.hasManualInputRole = authorizationService.isInRoles(manualInputRoles);
    }

    $onInit() {
        this._$scope.$watchGroup([() => this.currentBeginDate, () => this.currentEndDate], () => {
            this.currentInterval = { startDate: this.currentBeginDate, endDate: this.currentEndDate };
        });
    }
}

export const wtQualityAnalysis: ComponentDefinition = {
    componentId: 'wtQualityAnalysis',
    controller: QualityAnalysisController,
    template: require('./qualityAnalysis.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};